export default {
  name: 'Form',
  props: {
    disabled: { type: Boolean, default: false },
    data: { type: Object },
    model: {
      type: Function,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      form: this.model()
    }
  },
  computed: {
    disabledForm () {
      return !!this.disabled
    }
  },
  watch: {
    data: {
      immediate: true,
      handler () {
        this.$nextTick(() => {
          let _data = { ...this.data } || {}
          let oldFormData = this.copyObjectProps(this.model(), _data || {})
          let newFormData = this.copyObjectProps(this.model(), this.form)
          if (JSON.stringify(oldFormData) !== JSON.stringify(newFormData)) {
            this.handleData()
          }
        })
      }
    },
    form: {
      handler () {
        this.$emit('change', this.getData())
      },
      deep: true
    }
  },
  mounted () {
    this.handleData()
  },
  methods: {
    // HANDLERS
    handleData () {
      this.resetForm()
      this.form = this.copyObjectProps(this.model(), this.data || {})
    },
    // METHODS
    resetForm () {
      this.$refs.form && this.$refs.form.resetFields()
      this.clearValidate()
    },
    clearValidate () {
      this.$refs.form && this.$refs.form.clearValidate()
    },
    // Needs to delete
    updateModelItem (fieldName, payload = { }) {
      this.$nextTick(() => {
        this.$emit('updateModelItem', fieldName, this.form[fieldName], { ...payload, formData: this.getData() })
      })
    },
    // Needs to delete
    autoSave (field, payload = {}) {
      this.$nextTick(() => {
        const value = this.form[field]
        let { rules = [], required = false } = payload
        if (required) {
          rules = rules.concat(this.getValidationRule('required'))
        }

        this.$emit('onAutoSave', { ...payload, field, value, rules })
      })
    },
    autoSaveField (fieldName, payload = {}) {
      this.$nextTick(() => {
        const refForm = this.$refs.form
        if (!refForm) return
        refForm.validateField(fieldName, (errorMessage, arg2) => {
          const value = this.form[fieldName]
          if (!errorMessage) {
            this.$emit('onAutoSave', { ...payload, field: fieldName, value })
          }
        })
      })
    },
    /**
     * @desc Update data view (using for select event => on-data-value)
     * @param viewName { string }
     * @param data { object, null } - selected data
     * @param fieldDataName { string } - field name witch need to take from data as view
     */
    updateViewData (viewName, data, fieldDataName = viewName) {
      this.$emit('updateViewData', { [viewName]: data && data[fieldDataName] })
    },
    updateFormData (data) {
      this.form = this.copyObjectProps(this.getData(), data)
    },
    validate () {
      return new Promise((resolve, reject) => {
        this.$refs.form.validate(valid => {
          if (valid) {
            resolve()
          } else {
            reject(new Error('validate error'))
          }
        })
      })
    },
    getData () {
      return Object.assign({}, this.form)
    }
  }
}
